
<div *ngIf="imageRedirectURL else surveyLogo" class="redirectImageCont">
  <a [ngStyle]="{ 'pointer-events': imageRedirectURL ? 'all' : 'none' }" href="{{imageRedirectURL}}" target="_blank">
    <img alt="{{ImageAlt}}" src="{{imageName}}" (load)="setScroll()" />
  </a>
</div>

<ng-template #surveyLogo>

  <img alt="{{ImageAlt}}" src="{{imageName}}" (load)="setScroll()"/>
</ng-template>
